enum UserType {
    ALIBABA = "ALIBABA",

    AMAZON = "AMAZON",

    API_INTEGRATION = "API_INTEGRATION",

    BEIBEI = "BEIBEI",

    CHUCHUJIE = "CHUCHUJIE",

    CHUCHUJIE_PINTUAN = "CHUCHUJIE_PINTUAN",

    CHUCHUTONG = "CHUCHUTONG",

    DALINGJIA = "DALINGJIA",

    DANGDANG = "DANGDANG",

    FANGXINGOU = "FANGXINGOU",

    FANLI = "FANLI",

    GLOBAL_SCANNER = "GLOBAL_SCANNER",

    GUOMEI = "GUOMEI",

    HUIGUO = "HUIGUO",

    JD = "JD",

    JUANPI = "JUANPI",

    MEILISHUO = "MEILISHUO",

    MENGDIAN = "MENGDIAN",

    MIYA = "MIYA",

    MOGUJIE = "MOGUJIE",

    /** 官网注册的用户*/
    OFFICIAL_WEBSITE = "OFFICIAL_WEBSITE",

    PINDUODUO = "PINDUODUO",

    SUNING = "SUNING",

    TAOBAO = "TAOBAO",

    WECHAT = "WECHAT",

    WEIDIAN = "WEIDIAN",

    WEIMOB = "WEIMOB",

    WEIMOB_EC = "WEIMOB_EC",

    XIAODIAN = "XIAODIAN",

    YOUZAN = "YOUZAN",

    ZHE800 = "ZHE800",

    JINRITEMAI = "JINRITEMAI",

    JINRITEMAI_IOP = "JINRITEMAI_IOP",
}

export default UserType;
